import { FC, useState } from "react";
import styled from "styled-components";
import Logo from "../Icon/Logo";
import Button from "../Interface/Button";

type BoosterItemProps = {
  booster: {
    id: string;
    quantity: number;
    info: string;
  };
  handleOpenBooster: (boosterId: string, boosterSeason: string) => void;
  t: (key: string, fallback: string) => string;
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const getBackgroundFromSeason = (season: string): string => {
  if (season === "11") {
    // https://projects.verou.me/css3patterns/
    return `
    background-image: repeating-linear-gradient(
      120deg,
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0.1) 1px,
      transparent 1px,
      transparent 60px
    ),
    repeating-linear-gradient(
      60deg,
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0.1) 1px,
      transparent 1px,
      transparent 60px
    ),
    linear-gradient(
      60deg,
      rgba(0, 0, 0, 0.1) 25%,
      transparent 25%,
      transparent 75%,
      rgba(0, 0, 0, 0.1) 75%,
      rgba(0, 0, 0, 0.1)
    ),
    linear-gradient(
      120deg,
      rgba(0, 0, 0, 0.1) 25%,
      transparent 25%,
      transparent 75%,
      rgba(0, 0, 0, 0.1) 75%,
      rgba(0, 0, 0, 0.1)
    );
  );
  background-size: 34% 36%;
  `;
  } else if (season === "12") {
    return `  
background-image:
radial-gradient(circle at 100% 150%, rgba(17, 120, 1, 1) 24%, rgba(37, 143, 49, 1) 24%, rgba(37, 143, 49, 1) 28%, rgba(17, 120, 1, 1) 28%, rgba(17, 120, 1, 1) 36%, rgba(37, 143, 49, 1) 36%, rgba(37, 143, 49, 1) 40%, transparent 40%, transparent),
radial-gradient(circle at 0    150%, rgba(17, 120, 1, 1) 24%, rgba(37, 143, 49, 1) 24%, rgba(37, 143, 49, 1) 28%, rgba(17, 120, 1, 1) 28%, rgba(17, 120, 1, 1) 36%, rgba(37, 143, 49, 1) 36%, rgba(37, 143, 49, 1) 40%, transparent 40%, transparent),
radial-gradient(circle at 50%  100%, rgba(37, 143, 49, 1) 10%, rgba(17, 120, 1, 1) 10%, rgba(17, 120, 1, 1) 23%, rgba(37, 143, 49, 1) 23%, rgba(37, 143, 49, 1) 30%, rgba(17, 120, 1, 1) 30%, rgba(17, 120, 1, 1) 43%, rgba(37, 143, 49, 1) 43%, rgba(37, 143, 49, 1) 50%, rgba(17, 120, 1, 1) 50%, rgba(17, 120, 1, 1) 63%, rgba(37, 143, 49, 1) 63%, rgba(37, 143, 49, 1) 71%, transparent 71%, transparent),
radial-gradient(circle at 100% 50%, rgba(37, 143, 49, 1) 5%, rgba(17, 120, 1, 1) 5%, rgba(17, 120, 1, 1) 15%, rgba(37, 143, 49, 1) 15%, rgba(37, 143, 49, 1) 20%, rgba(17, 120, 1, 1) 20%, rgba(17, 120, 1, 1) 29%, rgba(37, 143, 49, 1) 29%, rgba(37, 143, 49, 1) 34%, rgba(17, 120, 1, 1) 34%, rgba(17, 120, 1, 1) 44%, rgba(37, 143, 49, 1) 44%, rgba(37, 143, 49, 1) 49%, transparent 49%, transparent),
radial-gradient(circle at 0    50%, rgba(37, 143, 49, 1) 5%, rgba(17, 120, 1, 1) 5%, rgba(17, 120, 1, 1) 15%, rgba(37, 143, 49, 1) 15%, rgba(37, 143, 49, 1) 20%, rgba(17, 120, 1, 1) 20%, rgba(17, 120, 1, 1) 29%, rgba(37, 143, 49, 1) 29%, rgba(37, 143, 49, 1) 34%, rgba(17, 120, 1, 1) 34%, rgba(17, 120, 1, 1) 44%, rgba(37, 143, 49, 1) 44%, rgba(37, 143, 49, 1) 49%, transparent 49%, transparent);
background-size: 44% 15%;
  `;
  } else if (season === "13") {
    return `
      background:
        repeating-linear-gradient(135deg, #258f31 0px, #258f31 4px, #0c5400 4px, #0c5400 8px),
        repeating-linear-gradient(45deg, #118001 0px, #118001 4px, #0c5400 4px, #0c5400 8px);
      background-size: 12px 12px;
    `;
  } else if (season === "14") {
    return `
      background:
        linear-gradient(45deg, #258f31 25%, #0c5400 25%, #0c5400 75%, #258f31 75%, #258f31),
        linear-gradient(45deg, #118001 25%, #0c5400 25%, #0c5400 75%, #118001 75%, #118001);
      background-size: 20px 20px;
      background-position: 0 0, 10px 10px;
    `;
  } else if (season === "15") {
    return `
      background:
        repeating-radial-gradient(circle at 50% 50%, #258f31 0px, #258f31 4px, #0c5400 4px, #0c5400 8px);
      background-size: 40px 40px;
    `;
  } else if (season === "16") {
    return `
      background:
        repeating-linear-gradient(135deg, #118001 0px, #118001 6px, #0c5400 6px, #0c5400 12px),
        repeating-linear-gradient(45deg, #258f31 0px, #258f31 6px, #0c5400 6px, #0c5400 12px);
      background-size: 20px 20px;
    `;
  } else if (season === "17") {
    return `
      background:
        repeating-linear-gradient(90deg, #258f31 0px, #258f31 10px, #0c5400 10px, #0c5400 20px),
        repeating-linear-gradient(0deg, #118001 0px, #118001 10px, #0c5400 10px, #0c5400 20px);
      background-size: 20px 20px;
    `;
  } else if (season === "18") {
    return `
      background:
        repeating-radial-gradient(circle at 25% 25%, #118001 0px, #118001 3px, #0c5400 3px, #0c5400 6px),
        repeating-radial-gradient(circle at 75% 75%, #258f31 0px, #258f31 3px, #0c5400 3px, #0c5400 6px);
      background-size: 24px 24px;
    `;
  } else if (season === "19") {
    return `
      background:
        repeating-linear-gradient(135deg, #258f31 0px, #258f31 8px, #0c5400 8px, #0c5400 16px),
        repeating-linear-gradient(45deg, #118001 0px, #118001 8px, #0c5400 8px, #0c5400 16px);
      background-size: 16px 16px;
    `;
  } else if (season === "20") {
    return `
      background:
        repeating-radial-gradient(circle at 50% 50%, #0c5400 0px, #0c5400 6px, #258f31 6px, #258f31 12px, #118001 12px, #118001 18px);
      background-size: 36px 36px;
    `;
  } else if (season === "21") {
    // Chevrons
    return `
      background:
        repeating-linear-gradient(-45deg, #258f31 0px, #258f31 6px, transparent 6px, transparent 12px),
        repeating-linear-gradient(45deg, #118001 0px, #118001 6px, #0c5400 6px, #0c5400 12px);
      background-size: 24px 24px;
    `;
  } else if (season === "22") {
    // Pois décalés
    return `
      background:
        radial-gradient(circle, #258f31 22%, transparent 23%),
        radial-gradient(circle, #118001 22%, transparent 23%),
        linear-gradient(#0c5400, #0c5400);
      background-size: 28px 28px, 28px 28px, 100% 100%;
      background-position: 0 0, 14px 14px, 0 0;
    `;
  } else if (season === "23") {
    // Rayures verticales larges
    return `
      background:
        repeating-linear-gradient(90deg, #0c5400 0px, #0c5400 8px, #118001 8px, #118001 16px, #258f31 16px, #258f31 24px);
      background-size: 24px 100%;
    `;
  } else if (season === "24") {
    // Losanges
    return `
      background:
        linear-gradient(135deg, #258f31 25%, transparent 25%),
        linear-gradient(225deg, #258f31 25%, transparent 25%),
        linear-gradient(315deg, #118001 25%, transparent 25%),
        linear-gradient(45deg, #118001 25%, #0c5400 25%);
      background-size: 22px 22px;
    `;
  } else if (season === "25") {
    // Vagues concentriques décalées
    return `
      background:
        repeating-radial-gradient(circle at 0% 50%, #118001 0px, #118001 5px, #0c5400 5px, #0c5400 10px),
        repeating-radial-gradient(circle at 100% 50%, #258f31 0px, #258f31 5px, #0c5400 5px, #0c5400 10px);
      background-size: 50px 50px;
    `;
  } else if (season === "26") {
    // Tissage / vannerie
    return `
      background:
        repeating-linear-gradient(0deg, #258f31 0px, #258f31 5px, transparent 5px, transparent 15px),
        repeating-linear-gradient(90deg, #118001 0px, #118001 5px, #0c5400 5px, #0c5400 15px);
      background-size: 30px 30px;
    `;
  } else if (season === "27") {
    // Zigzag horizontal
    return `
      background:
        linear-gradient(135deg, #118001 25%, transparent 25%) -10px 0,
        linear-gradient(225deg, #258f31 25%, transparent 25%) -10px 0,
        linear-gradient(315deg, #118001 25%, transparent 25%),
        linear-gradient(45deg, #258f31 25%, #0c5400 25%);
      background-size: 20px 20px;
    `;
  } else if (season === "28") {
    // Écailles
    return `
      background:
        radial-gradient(circle at 50% 0%, #258f31 30%, transparent 31%),
        radial-gradient(circle at 0% 100%, #118001 30%, transparent 31%),
        linear-gradient(#0c5400, #0c5400);
      background-size: 26px 26px, 26px 26px, 100% 100%;
      background-position: 0 0, 13px 13px, 0 0;
    `;
  } else if (season === "29") {
    // Grille fine sur fond sombre
    return `
      background:
        repeating-linear-gradient(0deg, #258f31 0px, #258f31 2px, transparent 2px, transparent 14px),
        repeating-linear-gradient(90deg, #258f31 0px, #258f31 2px, #0c5400 2px, #0c5400 14px);
      background-size: 14px 14px;
    `;
  } else if (season === "30") {
    // Rayons obliques doubles
    return `
      background:
        repeating-linear-gradient(60deg, #118001 0px, #118001 4px, transparent 4px, transparent 20px),
        repeating-linear-gradient(120deg, #258f31 0px, #258f31 4px, #0c5400 4px, #0c5400 20px);
      background-size: 40px 40px;
    `;
  }
  return "";
};

const BoosterWrapper = styled.div<{ season: string }>`
  user-select: none;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid #ccc;
  padding: 2em 1em;
  background: linear-gradient(
    135deg,
    rgba(19, 199, 2, 1) 0%,
    rgba(37, 143, 49, 1) 42%,
    rgba(17, 120, 1, 1) 100%
  );
  border: 1px solid #ccc;
  outline: 2px solid rgba(17, 120, 1, 1);
  border-radius: 3px;
  outline-style: groove;
  text-shadow: 1px 1px 0px rgb(6, 44, 0);
  filter: drop-shadow(2px 2px 3px rgb(6, 44, 0));

  background-color: rgba(17, 120, 1, 1);
  ${(props) => getBackgroundFromSeason(props.season)}
`;

const BoosterInfo = styled.div`
  color: white;
  font-size: 0.8em;
  padding: 2px 4px;
  font-weight: bold;
`;

const BoosterQuantity = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  color: white;
  background-color: red;
  border-radius: 5px;
  font-size: 0.65em;
  padding: 2px 6px;
  font-weight: bold;

  background: linear-gradient(rgb(180 73 73) 0%, rgb(203 97 97) 100%);
  box-shadow: 0px 3px 0px #8f2b2b, 0px 3px 15px rgba(0, 0, 0, 0.4),
    inset 0px 1px 0px rgba(255, 255, 255, 0.3),
    inset 0px 0px 3px rgba(255, 255, 255, 0.5);
`;

const LogoWrapper = styled.div`
  filter: drop-shadow(0 0 2px #ffffff);
`;

export const BoosterItem: FC<BoosterItemProps> = ({
  booster,
  handleOpenBooster,
  t,
}) => {
  const [total, setTotal] = useState(booster.quantity);

  const handleOpen = (boosterId: string) => {
    handleOpenBooster(boosterId, booster.info);
    setTotal((t) => t - 1);
  };
  if (total === 0) {
    return null;
  }
  return (
    <Wrapper>
      <BoosterWrapper season={booster.info}>
        <span className="gr-shadow1"></span>
        <LogoWrapper>
          <Logo img={"logo.svg"} width={"50px"} height={"50px"} />
        </LogoWrapper>
        <BoosterInfo>S{booster.info}</BoosterInfo>
        <BoosterQuantity>x{total}</BoosterQuantity>
      </BoosterWrapper>
      <Button onClick={() => handleOpen(booster.id)}>
        {t("t:open one booster", "__open one booster")}
      </Button>
    </Wrapper>
  );
};

export default BoosterItem;
